/*
 * File: ConfigurationContainer.js
 * Project: KuvaDash
 * Author: Corey Wirun
 * Copyright (c) 2020 Kuva
 */
class ConfigurationContainer {
  constructor() {
    this.variables = {};
  }

  get = key => {
    let value = null;
    // eslint-disable-next-line
    if (this.variables.hasOwnProperty(key)) {
      value = this.variables[key];
    }

    return value;
  };

  getAll = () => {
    return this.variables;
  };

  set = (key, value) => {
    this.variables[key] = value;
    console.log(`configuration ${key} = ${this.variables[key]}`);
  };

  load = data => {
    let keys = Object.keys(data);
    for (let index = 0; index < keys.length; index++) {
      this.set(keys[index], data[keys[index]]);
    }
  };
}

export default new ConfigurationContainer();
